import { environment } from "src/environments/environment";

export var GLOBAL = {
    nombreMuni: 'Peñaflor',
    //env: 'http://localhost:4200',  //local
    env: 'https://pnf.smartdom.cl',  // test  //IMPORTANTE!!!! siempre cambiar segun el ambiente al que se subira
    //env: 'https://penaflor.smartdom.cl', // prod  //IMPORTANTE!!!! siempre cambiar segun el ambiente al que se subira

    //url: 'http://localhost:3917/api/v1/', //local
    url: environment.backUrl + '/api/v1/', 


    pdfUrl: 'https://download.nidx.solnet.cl:3917/api/v1/download',
    region: 'REGIÓN METROPOLITANA',
    filedomSolicitudUrl: 'https://penaflor.smartdom.cl/#/certificados/', //solicitud certificados
    filedomSeguimientoUrl: 'http://penaflor.filedom.cl/seguimiento_certificados/',//seguimientos certificados
    seguimientoSolicitudes: 'http://penaflor.filedom.cl/seguimiento_solicitudes',
    seguimientoCertificados: 'http://penaflor.filedom.cl/',
    mapasUrl: 'http://penaflor.filedom.cl/mapas/',
    footer: 'Dirección de Obras Municipales - Alcalde Luis Araya Cereceda N ° 1215, Peñaflor, Región Metropolitana',
    webUrl: 'https://www.penaflor.cl',
    web: 'www.penaflor.cl',
    acotado: true,
    docAccept: ".jpg,.png,.DWG,.dwg,.pdf,.docx,.doc,.xls,.xlsx",
    correos: ["claudio.diaz@penaflor.cl", "catalina.mancilla@penaflor.cl", "francisco.vera@penaflor.cl"],
}
